// Help content map: route path → { screenName, faqs, formulas, quickstart }
const helpContent = {
  '/main-dashboard': {
    screenName: 'Dashboard Principal',
    faqs: [
      {
        q: '¿Qué es la exposición total?',
        a: 'Es la suma de qty × yield × benchmark_EUR por todos los lotes activos. Representa el valor de mercado actual de tu inventario en euros. El panel de riesgo de inventario desglosa esta exposición lote a lote con P&L latente en tiempo real.'
      },
      {
        q: '¿Qué muestra el panel de riesgo de inventario?',
        a: 'Una tabla de lotes activos ordenada por exposición, con P&L latente en tiempo real, días en inventario y badge de riesgo LOW/MEDIUM/HIGH. Permite identificar de un vistazo qué posiciones están en pérdida o en riesgo de estarlo.'
      },
      {
        q: '¿Cómo usar el simulador de escenarios?',
        a: 'Elige el alcance — todo el inventario, por metal o por categoría — selecciona el tipo de shock — benchmark, EUR/USD o combinado — y ajusta la magnitud. El sistema muestra el impacto en cartera, los lotes que entrarían en pérdida y una recomendación automática.'
      },
      {
        q: '¿Qué significa pérdida potencial -5%?',
        a: 'Cuánto perderías si el benchmark cae un 5% desde hoy. Se calcula multiplicando tu exposición total por el porcentaje de caída.'
      },
      {
        q: '¿Por qué cambian los benchmarks solos?',
        a: 'El sistema está suscrito en tiempo real a market_ticks vía Supabase Realtime. Cada vez que introduces un nuevo precio en Datos de Mercado, todos los cálculos se actualizan automáticamente.'
      }
    ],
    formulas: [
      { name: 'Exposición EUR', formula: 'exposure_EUR = Σ(qty_t × yield × benchmark_EUR)' },
      { name: 'Pérdida potencial', formula: 'potential_loss = exposure × shock_pct' },
      { name: 'P&L latente por lote', formula: 'latent_PnL = (benchmark_EUR_hoy × yield − buy_price) × qty_t' },
      { name: 'Punto de equilibrio lote', formula: 'punto_equilibrio_lote = (costes + margen + riesgo_asumido) / yield' }
    ],
    quickstart: '1. Revisa los KPIs de riesgo (exposición, pérdidas potenciales, lotes en riesgo). 2. Analiza el panel de inventario para identificar posiciones con P&L negativo. 3. Usa el simulador para ver qué pasaría si el mercado se mueve. 4. Atiende las alertas activas.'
  },

  '/': {
    screenName: 'Gestión de Lotes Activos',
    faqs: [
      {
        q: '¿Cuándo cambio el estado de un lote?',
        a: 'Activo → Procesando cuando empieza el tratamiento del material. Procesando → Vendido al cerrar la venta con el comprador.'
      },
      {
        q: '¿Puedo editar un lote después de crearlo?',
        a: 'Sí, usando el icono de edición en la fila del lote. Puedes modificar peso, yield, costes y otros parámetros.'
      },
      {
        q: '¿Qué muestra el historial del lote?',
        a: 'Una línea de tiempo con todos los cambios de estado, precios registrados y el margen realizado vs estimado al momento de la venta.'
      }
    ],
    formulas: [
      { name: 'Días en inventario', formula: 'days_in_inventory = hoy − created_at' },
      { name: 'Delta de margen', formula: 'margin_delta = realized_margin − estimated_margin' }
    ],
    quickstart: '1. Los lotes se crean desde la Calculadora. 2. Cambia el estado conforme avanza el material. 3. Usa "Ver historial" para ver la evolución completa.'
  },

  '/active-batch-management': {
    screenName: 'Gestión de Lotes Activos',
    faqs: [
      {
        q: '¿Cuándo cambio el estado de un lote?',
        a: 'Activo → Procesando cuando empieza el tratamiento del material. Procesando → Vendido al cerrar la venta con el comprador.'
      },
      {
        q: '¿Puedo editar un lote después de crearlo?',
        a: 'Sí, usando el icono de edición en la fila del lote. Puedes modificar peso, yield, costes y otros parámetros.'
      },
      {
        q: '¿Qué muestra el historial del lote?',
        a: 'Una línea de tiempo con todos los cambios de estado, precios registrados y el margen realizado vs estimado al momento de la venta.'
      }
    ],
    formulas: [
      { name: 'Días en inventario', formula: 'days_in_inventory = hoy − created_at' },
      { name: 'Delta de margen', formula: 'margin_delta = realized_margin − estimated_margin' }
    ],
    quickstart: '1. Los lotes se crean desde la Calculadora. 2. Cambia el estado conforme avanza el material. 3. Usa "Ver historial" para ver la evolución completa.'
  },

  '/batch-calculator': {
    screenName: 'Calculadora de Lotes',
    faqs: [
      {
        q: '¿Cómo se calcula el precio máximo de compra?',
        a: 'Se resta al valor recuperable todos los costes (logística, procesamiento), el margen objetivo y el buffer de riesgo. Lo que queda es el máximo que puedes pagar.'
      },
      {
        q: '¿Qué es el yield?',
        a: 'El porcentaje de metal recuperable tras el procesamiento. Si compras 1 tonelada con yield 85%, obtendrás 0,85 t de metal puro para vender.'
      },
      {
        q: '¿Qué modo de buffer debo usar?',
        a: 'Dinámico si tienes histórico de ticks de mercado — el sistema calcula la volatilidad real. Manual si estás empezando y prefieres fijar tú mismo el porcentaje de seguridad.'
      },
      {
        q: '¿Qué es el Precio de Compra Negociado?',
        a: 'El precio real al que decides comprar el lote tras la negociación — puede ser superior al máximo calculado. Si introduces un precio por encima del máximo, el sistema calcula el riesgo asumido y el margen resultante para que sepas exactamente cuánto margen de protección estás sacrificando.'
      },
      {
        q: '¿Qué significa ACEPTABLE / ELEVADO / CRÍTICO?',
        a: 'Son badges de riesgo que aparecen cuando el precio negociado supera el máximo calculado: ACEPTABLE cuando pagas hasta un 2% por encima — riesgo manejable; ELEVADO entre el 2% y el 5% — el buffer de protección está significativamente comprometido; CRÍTICO más del 5% — alta probabilidad de pérdida si el mercado se mueve en tu contra.'
      },
      {
        q: '¿Por qué hay tres sigmas en el buffer dinámico?',
        a: 'σ LME USD captura la volatilidad del metal en dólares en los últimos 90 días. σ EUR/USD captura los movimientos históricos del tipo de cambio usando el valor real de cada día. σ combinada EUR es la que realmente importa — captura ambas fuentes de riesgo simultáneamente calculando los retornos diarios como LME_USD_día / EURUSD_día, usando precios históricos reales en EUR por día.'
      }
    ],
    formulas: [
      { name: 'Valor recuperable', formula: 'recoverable_value = yield × sell_price_expected' },
      { name: 'Precio máximo de compra', formula: 'max_buy = recoverable_value − logistics − processing − target_margin − risk_buffer' },
      { name: 'Precio EUR histórico', formula: 'eurPrice_i = LME_USD_i / EURUSD_i  (tipo de cambio histórico del día)' },
      { name: 'Retorno diario', formula: 'daily_return_i = (eurPrice_i − eurPrice_{i−1}) / eurPrice_{i−1}' },
      { name: 'Buffer dinámico', formula: 'risk_buffer = σ_combinada × √días × 1.65 × benchmark_EUR_hoy × yield' },
      { name: 'Riesgo asumido', formula: 'riesgo_asumido = precio_negociado − max_buy_price' },
      { name: 'Margen real resultante', formula: 'margen_real = margen_objetivo − riesgo_asumido' },
      { name: 'Punto de equilibrio', formula: 'punto_equilibrio = (costes + margen + riesgo_asumido) / yield' }
    ],
    quickstart: '1. Selecciona metal y categoría. 2. Introduce el peso bruto y la tara. 3. Revisa los defaults o ajústalos. 4. Pulsa Calcular para obtener el precio máximo. 5. Si negocias por encima del precio máximo, introduce el precio negociado para ver el riesgo asumido y el margen real resultante.'
  },

  '/inventory': {
    screenName: 'Inventario',
    faqs: [
      {
        q: '¿Cómo se calcula la exposición por metal?',
        a: 'Multiplicando la cantidad en toneladas por el yield y por el benchmark EUR actual. Refleja el valor de mercado de ese metal en tu inventario.'
      },
      {
        q: '¿Qué es el P&L latente?',
        a: 'La diferencia entre el valor actual del inventario (benchmark hoy × yield × qty) y el precio de compra que pagaste. Positivo = ganancia no realizada, negativo = pérdida no realizada.'
      },
      {
        q: '¿Qué significa la alerta de antigüedad?',
        a: 'El lote lleva más días en inventario de los configurados en Umbrales de Riesgo sin venderse. Conviene revisar si el precio de compra sigue siendo rentable.'
      }
    ],
    formulas: [
      { name: 'Exposición EUR', formula: 'exposure_EUR = qty_t × yield × benchmark_EUR' },
      { name: 'P&L latente', formula: 'latent_PnL = (benchmark_EUR_hoy × yield − buy_price) × qty_t' }
    ],
    quickstart: '1. Los lotes activos y en proceso aparecen aquí automáticamente. 2. Usa "Marcar como vendido" para registrar la venta y capturar el margen real.'
  },

  '/inventory-management': {
    screenName: 'Inventario',
    faqs: [
      {
        q: '¿Cómo se calcula la exposición por metal?',
        a: 'Multiplicando la cantidad en toneladas por el yield y por el benchmark EUR actual. Refleja el valor de mercado de ese metal en tu inventario.'
      },
      {
        q: '¿Qué es el P&L latente?',
        a: 'La diferencia entre el valor actual del inventario (benchmark hoy × yield × qty) y el precio de compra que pagaste. Positivo = ganancia no realizada, negativo = pérdida no realizada.'
      },
      {
        q: '¿Qué significa la alerta de antigüedad?',
        a: 'El lote lleva más días en inventario de los configurados en Umbrales de Riesgo sin venderse. Conviene revisar si el precio de compra sigue siendo rentable.'
      }
    ],
    formulas: [
      { name: 'Exposición EUR', formula: 'exposure_EUR = qty_t × yield × benchmark_EUR' },
      { name: 'P&L latente', formula: 'latent_PnL = (benchmark_EUR_hoy × yield − buy_price) × qty_t' }
    ],
    quickstart: '1. Los lotes activos y en proceso aparecen aquí automáticamente. 2. Usa "Marcar como vendido" para registrar la venta y capturar el margen real.'
  },

  '/sales-analysis': {
    screenName: 'Análisis de Ventas',
    faqs: [
      {
        q: '¿Qué es la desviación de yield?',
        a: 'La diferencia entre el yield estimado al comprar y el yield real obtenido al vender. Sirve para calibrar tus estimaciones futuras y mejorar la precisión del precio máximo.'
      },
      {
        q: '¿Cómo interpretar el panel de compradores?',
        a: 'Muestra qué compradores te pagan mejor descuento y mayor precio medio. Útil para priorizar a quién vender según el tipo de material.'
      },
      {
        q: '¿Para qué sirve la calibración de descuentos?',
        a: 'Compara el descuento que asumiste al comprar con el que realmente te aplicaron al vender. Si hay desviación sistemática, ajusta tus parámetros de compra.'
      }
    ],
    formulas: [
      { name: 'Margen realizado', formula: 'realized_margin = (sale_price × real_yield) − buy_price − logistics − processing' },
      { name: 'Desviación de yield', formula: 'yield_deviation = real_yield_pct − est_yield_pct' }
    ],
    quickstart: '1. Las ventas aparecen aquí automáticamente al marcar lotes como vendidos. 2. Usa los filtros de fecha para analizar períodos concretos. 3. Exporta a CSV para análisis externo.'
  },

  '/market-data': {
    screenName: 'Datos de Mercado',
    faqs: [
      {
        q: '¿Con qué frecuencia debo actualizar los precios?',
        a: 'Idealmente una vez al día consultando LME directamente. El sistema recalcula todo en tiempo real al guardar, propagando los nuevos benchmarks a calculadora e inventario.'
      },
      {
        q: '¿Qué es el símbolo EUR_USD?',
        a: 'El tipo de cambio euro/dólar. Es imprescindible para convertir los precios LME (cotizados en USD/t) a euros. Sin este dato, los benchmarks EUR no se pueden calcular.'
      },
      {
        q: '¿Por qué es importante el EUR/USD histórico?',
        a: 'El buffer de riesgo dinámico usa el tipo de cambio real de cada día histórico para calcular los retornos en EUR — sin histórico EUR/USD el VaR está subestimado porque solo captura la volatilidad del metal en USD, ignorando los movimientos del tipo de cambio.'
      },
      {
        q: '¿Con qué frecuencia actualizar EUR/USD?',
        a: 'Idealmente cada día antes de hacer cálculos. Un movimiento del 2% en EUR/USD impacta directamente en todos los precios máximos de compra y en el buffer de riesgo dinámico de todos los metales.'
      },
      {
        q: '¿Qué pasa si no tengo precio para un metal regional?',
        a: 'Puedes usar el último precio de venta como referencia manual hasta tener datos más fiables. El sistema lo marcará como precio manual para distinguirlo de los datos LME.'
      }
    ],
    formulas: [
      { name: 'Benchmark EUR', formula: 'benchmark_EUR = LME_USD / EURUSD' },
      { name: 'Precio esperado (absoluto)', formula: 'sell_price_expected = benchmark_EUR − discount' },
      { name: 'Precio esperado (porcentaje)', formula: 'sell_price_expected = benchmark_EUR × (1 − discount_pct)' }
    ],
    quickstart: '1. Introduce EUR/USD primero. 2. Luego introduce el precio LME de cada metal en USD/t. 3. El sistema convierte y propaga automáticamente a calculadora e inventario.'
  },

  '/alerts-dashboard': {
    screenName: 'Panel de Alertas',
    faqs: [
      {
        q: '¿Cuándo se generan las alertas automáticamente?',
        a: 'En cada actualización de market_ticks en tiempo real vía Supabase Realtime. Cada vez que llega un nuevo tick de mercado, el sistema evalúa todas las reglas activas y genera alertas para las que superen el umbral configurado — sin necesidad de ninguna acción manual.'
      },
      {
        q: '¿Qué diferencia hay entre reconocer y resolver una alerta?',
        a: 'Reconocer = la has visto, sigues monitorizando la situación. Resolver = el problema ha sido atendido; puedes añadir una nota de resolución para el registro.'
      },
      {
        q: '¿Puedo crear mis propias reglas?',
        a: 'Sí, desde el panel Reglas de Alerta. Elige el tipo de alerta, el umbral numérico y el scope (metal específico, categoría o todos).'
      }
    ],
    formulas: [],
    quickstart: '1. Configura primero los umbrales en Configuración → Umbrales de Riesgo. 2. Activa las reglas que necesites. 3. Las alertas se generan automáticamente con cada actualización de mercado en tiempo real.'
  },

  '/settings': {
    screenName: 'Configuración',
    faqs: [
      {
        q: '¿Puedo añadir mis propios metales?',
        a: 'Sí, desde el Catálogo → Nuevo grupo de metal. Puedes crear grupos con benchmark LME, índice regional o precio manual según disponibilidad de datos.'
      },
      {
        q: '¿Qué pasa si cambio el yield por defecto de una categoría?',
        a: 'Afecta solo a los nuevos lotes. Los lotes ya creados conservan el yield con el que fueron calculados originalmente, garantizando la trazabilidad.'
      },
      {
        q: '¿Con qué frecuencia debo revisar los parámetros de volatilidad?',
        a: 'Recomendable revisar mensualmente o tras movimientos bruscos de mercado (±10% en pocos días). Una volatilidad desactualizada puede inflar o reducir el buffer de riesgo.'
      },
      {
        q: '¿Qué hace el botón Exportar configuración?',
        a: 'Descarga un JSON con todas tus categorías, umbrales, volatilidades y preferencias — útil como backup o para transferir la configuración a otro entorno sin tener que reintroducir todos los parámetros manualmente.'
      },
      {
        q: '¿Cómo importar una configuración?',
        a: 'Sube el JSON exportado previamente — el sistema muestra un resumen de lo que se importará y sobreescribirá antes de confirmar, para que puedas revisar los cambios antes de aplicarlos.'
      }
    ],
    formulas: [],
    quickstart: '1. Configura tus categorías con yields y costes reales de tu operación. 2. Ajusta los umbrales de riesgo a tu tamaño de negocio. 3. Revisa la volatilidad por metal periódicamente.'
  },

  '/preferences': {
    screenName: 'Preferencias',
    faqs: [
      {
        q: '¿El modo oscuro afecta a otros usuarios?',
        a: 'No — es una preferencia personal guardada en tu perfil. Cada usuario puede tener su propio tema sin afectar a los demás.'
      },
      {
        q: '¿Puedo cambiar mi email?',
        a: 'Sí, desde la pestaña Perfil. Recibirás un email de confirmación en el nuevo correo antes de que el cambio sea efectivo.'
      },
      {
        q: '¿Qué son los defaults del motor de precios?',
        a: 'Valores que pre-rellenan la calculadora cada vez que abres un nuevo lote. Ahorran tiempo si siempre usas los mismos parámetros de logística, procesamiento y margen.'
      }
    ],
    formulas: [],
    quickstart: '1. Configura tu moneda y formato numérico preferido. 2. Elige qué metales mostrar en el Dashboard. 3. Define tus defaults de calculadora para ir más rápido.'
  },

  '/help': {
    screenName: 'Ayuda',
    faqs: [
      {
        q: '¿Dónde encuentro las fórmulas completas?',
        a: 'En la pestaña Referencia de Fórmulas de esta misma pantalla. Están organizadas por módulo con ejemplos numéricos.'
      },
      {
        q: '¿Cómo reporto un error?',
        a: 'Desde la pestaña Soporte → formulario de reporte de incidencia. Incluye capturas de pantalla si es posible para agilizar la resolución.'
      }
    ],
    formulas: [],
    quickstart: 'Usa la pestaña Primeros pasos para un recorrido guiado por todas las funcionalidades de la aplicación.'
  }
};

export default helpContent;
